import { MobXProviderContext, observer } from 'mobx-react';
import { ContactModelV2 } from 'Models/ContactModelV2';
import React, { useContext } from 'react';
import { RootStoreProps } from 'Stores/RootStore.types';
import { mapContactCategory } from '../../../../../utils/map_contact_category';
import { EntityContactCard } from '../../../../EntityContactCard';
import { GroupMemberCardProps } from './index.types';

export const GroupMemberCard = observer(
  ({ contact, openContactDetails }: GroupMemberCardProps) => {
    const { person: personStore, ui: uiStore } = useContext(
      MobXProviderContext
    ) as RootStoreProps;

    const category = () => {
      if (
        contact instanceof ContactModelV2 &&
        contact.sourceId === personStore.loggedInPersonId.toString()
      ) {
        return 'You';
      }

      return mapContactCategory(contact);
    };

    // Calculate presence directly from MobX store instead of using useState
    // This ensures the component re-renders when presence changes
    const presence =
      contact instanceof ContactModelV2 && contact.sourceId
        ? uiStore.selectPersonPresenceStatus(contact.sourceId)
        : null;

    if (contact instanceof ContactModelV2) {
      return (
        <EntityContactCard
          image={contact.avatarUrl}
          name={contact.name}
          subTitle={category()}
          presence={presence}
          hasContact
          isInactive={contact.deleted}
          onNavigateToContact={() => openContactDetails(contact)}
        />
      );
    }

    return (
      <EntityContactCard
        name={contact.FormattedPhone}
        subTitle={category()}
        hasContact
        onNavigateToContact={() => openContactDetails(contact)}
        isUnsaved
      />
    );
  }
);
